import React from 'react';
import { Text, TextButton } from '@wix/design-system';
import { PremiumEssentialsProvider, usePremiumEssentialsContext, } from '@wix/premium-fed-sdk/@premium-essentials';
import { useTranslation } from '../../../Infra';
import { DomainsSharedComponentsModule } from '../../../Provider/DomainsSharedComponentsModule';
import cardImage from '../../../assets/success-page/connect-success-card.png';
import { BaseSuccessPage } from './BaseSuccessPage';
export const ConnectedDomainSuccessPage = ({ ...props }) => {
    const { i18n, Trans } = usePremiumEssentialsContext();
    return (React.createElement(PremiumEssentialsProvider, { i18n: i18n, Trans: Trans },
        React.createElement(DomainsSharedComponentsModule.Provider, { DomainsSharedTranslations: {
                Loading: React.createElement(React.Fragment, null),
            } },
            React.createElement(ConnectedDomainSuccessPageContent, { ...props }))));
};
const ConnectedDomainSuccessPageContent = ({ siteDomain, siteName = '', siteId, }) => {
    const { t, Trans } = useTranslation();
    const viewSiteLink = `https://${siteDomain}`;
    const dashboardLinkUrl = `https://manage.wix.com/account/sites/${siteId ?? ''}`;
    return (React.createElement(BaseSuccessPage, { card: {
            title: t('my-domains-shared-components.new.assign_success.title', {
                domainName: siteDomain,
                siteName,
            }),
            body: t('my-domains-shared-components.status.assign_success.already_published'),
            action: {
                as: 'a',
                href: viewSiteLink,
                children: t('my-domains-shared-components.status.assign_success.view_site'),
            },
            image: {
                src: cardImage,
            },
        }, footer: {
            body: (React.createElement(Text, { size: 'small' },
                React.createElement(Trans, { i18nKey: 'my_domains.premium_anywhere.success_page.footer.go_to_dashboard', components: [
                        React.createElement(TextButton, { as: 'a', href: dashboardLinkUrl, skin: 'dark', underline: 'always', weight: 'bold', size: 'small' }),
                    ] }))),
        } }));
};
//# sourceMappingURL=ConnectedDomainSuccessPage.js.map